// @ts-nocheck
import * as territoryApi from '../api/territoryApi';
import actionTypes from '../constants/actionTypes';

export function saveTerritory(territory) {
  return function (dispatch) {
    return territoryApi.saveTerritory(territory).then((savedTerritory) => {
      dispatch({
        type: territory.id
          ? actionTypes.UPDATE_TERRITORY
          : actionTypes.CREATE_TERRITORY,
        territory: { ...territory, id: savedTerritory.id },
      });
    });
  };
}

export function getTerritoryById(id) {
  return territoryApi.getTerritoryById(id);
}

export function loadTerritories(params) {
  return territoryApi.getTerritories(params);
}

export function getAllTerritories() {
  return function (dispatch) {
    return territoryApi.getAllTerritories().then((territories) => {
      dispatch({
        type: actionTypes.LOAD_TERRITORIES,
        territories,
      });
    });
  };
}

export function loadAllowedSkus(params) {
  const { territoryId, ...rest } = params;
  return territoryApi.getAllowedSkus(territoryId, rest);
}

export function loadDisallowedSkus(params) {
  const { territoryId, ...rest } = params;
  return territoryApi.getDisallowedSkus(territoryId, rest);
}

export function deleteTerritory(id) {
  return function (dispatch) {
    return territoryApi.deleteTerritory(id).then(() => {
      dispatch({
        type: actionTypes.DELETE_TERRITORY,
        id,
      });
    });
  };
}

export function exportTerritoryData(filters, scopes) {
  return territoryApi.exportTerritoryData(filters, scopes);
}

export function getStats(id) {
  return territoryApi.getStats(id);
}
